// gatsby-browser.js
import "./src/styles/global.css"
import "./node_modules/bootstrap/dist/css/bootstrap.css";